import { Modal, Spin } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useScreenSize from 'src/core/ui/hooks/use-screen-size';
import { Languages } from 'src/i18n';
import { getLocalizedDataFromTutorialItem, getYoutubeVideoUrlFromId, TutorialSummary } from 'src/stores/video-tutorials-store';

export const TutorialVideoPlayer = ({ videoData, hideVideoPlayer }: { videoData: TutorialSummary; hideVideoPlayer: () => void }) => {
  const { i18n } = useTranslation();
  const screenSize = useScreenSize();
  const displayInformation = getLocalizedDataFromTutorialItem(videoData, i18n.language as Languages);

  const [isIFrameLoaded, setIsIFrameLoaded] = useState<boolean>(false);

  return (
    <Modal
      open
      width={1200}
      title={displayInformation.title}
      onCancel={hideVideoPlayer}
      footer={<div style={{ textAlign: 'start', maxHeight: 200, overflow: 'auto', scrollbarWidth: 'thin' }}>{displayInformation.description}</div>}
    >
      <Spin spinning={!isIFrameLoaded}>
        <iframe
          style={{ border: 0 }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          src={`${getYoutubeVideoUrlFromId(videoData.universalId)}?hl=${i18n.language}`}
          title={displayInformation.title}
          width={'100%'}
          height={`${screenSize.height * 0.65}px`}
          onLoad={() => setIsIFrameLoaded(true)}
        />
      </Spin>
    </Modal>
  );
};
